import React, { useEffect, useState } from 'react';
import { Loading, Error, useNotify } from 'react-admin';
import {
  Box, IconButton
} from '@material-ui/core';
import {
  ListAlt as ListAltIcon
} from '@material-ui/icons';
import { useQuery } from '../util/locationHelper';
import {
  firstDateOfMonth, getYearMonthDate, 
  getPrevMonthDay, getNextMonthDay, compareDates, getYearMonth
} from '../calendar'

import { reqSettle, reqPatchMemo, reqMonthlyOrders } from "./api";
import { 
  SettlementCalendar, SettlementInfo, presentAdjustSum 
} from '../settlement-supplier-calendar';
import CustomerListDialog from "./CustomerListDialog";
import { presentSettlement } from './presenters';
import { Actions, Resources, useHasPermissions } from '../lib/react-admin-loopback';

// query params 에 고객사 정보 없는 경우 
const defaultCustomer = { id: 103, name: '나를위한산부인과' };

/**
 * 22년 5월 이후는 변경된 정산 api 적용 
 */
 const newApi = (firstDate) => {
  return compareDates(firstDate, new Date('2022-05-01T09:00:00')) >= 0;
}

const CustomerCalendar = (props) => {

  const hasPermission = useHasPermissions(
    Resources.CustomerOrders,
    Actions.Show,
    () => {
      alert('권한이 없습니다.');
      props.history.push('/cm-stlist');
    }
  );

  const notify = useNotify();
  
  const { query, updateQuery } = useQuery();

  const [ firstDate, setFirstDate ] = useState(firstDateOfMonth(new Date()));
  const [ data, setData ] = useState();
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState();
  const [ openDlgCustomers, setOpenDlgCustomers ] = useState(false);

  const customer = query.id ? query : defaultCustomer;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (newApi(firstDate)) {
          const { data: result } = await reqMonthlyOrders(customer.id, firstDate);
          setData(presentSettlement(result));
        }
        else {
          const { data: result } = await reqSettle(customer.id, firstDate);
          setData(result);
        }
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
        // LATER: server logging 
        console.error(err);
      }
    }

    fetchData();
  }, [ customer, firstDate ]);

  const handleClickPrev = () => {
    setFirstDate(getPrevMonthDay(firstDate));
  }

  const handleClickNext = () => {
    setFirstDate(getNextMonthDay(firstDate));
  }

  const handleSaveMemo = async (date, memo) => {
    try {
      // patch data 
      const result = await reqPatchMemo(customer.id, date, memo);
      // check result 

      // reload 
      setFirstDate(getNextMonthDay(getPrevMonthDay(firstDate)));
    } catch (err) {
      console.error(err);
      notify(`저장에 실패했습니다. 관리자에게 문의해주세요. \n오류: ${err}`, 'error');
    }
  }

  const handleClickCustomerList = () => {
    setOpenDlgCustomers(true);
  }

  const handleClose = () => {
    setOpenDlgCustomers(false);
  }

  const handleSelect = customer => {
    setOpenDlgCustomers(false);
    updateQuery(customer);
  }

  const yearMonth = getYearMonth(firstDate);
  const downloadUrl = `${process.env.REACT_APP_FCS_API_URL}/orders-bs/download?customerId=${customer.id}&yearMonth=${yearMonth}`;
  const downloadName = `${customer.name}-${yearMonth}.xlsx`;

  if (loading || !data) return <Loading />;
  if (error) return <Error error={error} />;

  const { 
    sellAmount, adjust, operationFee, vat, calculated, totalQty, kpi 
  } = data.total ?? {};

  return (
    <div>
      <h1>
        고객사 정산
      </h1>
      {/* 고객사 */}
      <div>
        <span>{customer.name}</span>
        <IconButton
          aria-label="change customer"
          onClick={handleClickCustomerList}
        >
          <ListAltIcon />
        </IconButton>
      </div>
      <Box
        display="flex"
      >
        <SettlementInfo title="총 매출" value={sellAmount} />
        <SettlementInfo title="조정액" value={adjust ? presentAdjustSum(adjust) : ''} />
        <SettlementInfo title="운영비" value={operationFee} />
        {/* <SettlementInfo title="부가세" value={vat} /> */}
        <SettlementInfo title="총 청구액" value={calculated} />
        <SettlementInfo title="총 식수량" value={totalQty} />
        <SettlementInfo title="KPI-일평균식수" value={kpi} />
        <div>
          <a href={downloadUrl} download={downloadName}>명세서 다운로드</a>
        </div>
      </Box>
      {/* calendar */}
      <div>
        <SettlementCalendar
          firstDate={firstDate}
          data={data}
          onClickPrev={handleClickPrev}
          onClickNext={handleClickNext}
          onSaveMemo={handleSaveMemo}
        />
      </div>
      <CustomerListDialog
        open={openDlgCustomers}
        onClose={handleClose}
        onSelect={handleSelect}
      />
    </div>
  )

}

export default CustomerCalendar;